"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApWidgetBulletList = exports.ApWidgetBullet = void 0;
var React = require("react");
var styles_1 = require("./styles");
exports.ApWidgetBullet = function (_a) {
    var value = _a.value;
    return (React.createElement(styles_1.Wrapper, null,
        React.createElement(styles_1.Value, null, value)));
};
exports.ApWidgetBulletList = function (_a) {
    var list = _a.list;
    return (React.createElement(styles_1.ListWrapper, null, list
        .filter(function (x) { return x; })
        .map(function (value, index) { return (React.createElement(exports.ApWidgetBullet, { value: value, key: value.toString() + index })); })));
};
//# sourceMappingURL=ApWidgetBullet.js.map